import React from 'react';
import './Header.css';
import { Link } from 'react-router-dom';

function Header() {
    return (
        <header className="header navbar navbar-expand-lg navbar-light bg-light fixed-top mt-2">
            <div className="container">
                <Link className="navbar-brand nav-logo" to="/">
                    <img src='/images/logo.svg' alt="Logo" className="logo-img" />
                    <span className="logo-text"><em>We deliver efficiency</em></span>
                </Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <Link className="nav-link" to="/values">HR Solutions</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/about">About</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/services">Services</Link>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#agencies">Agencies</a>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/contact-us">Contact Us</Link>
                        </li>
                    </ul>
                    <a className="btn btn-primary ml-lg-3" href="#talk-to-sales">Talk to Sales</a>
                </div>
            </div>
        </header>
    );
}

export default Header;
